export default "__VITE_PUBLIC_ASSET__222eb2f7__"